import React from "react";
import logoBig from "../../images/logos/logo_big.png";
import shape3 from "../../images/shapes/love-shape2.svg";
import { Fade, Zoom } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="hero hero--style1 overflow-hidden">
      <img src={shape3} alt="" aria-hidden="true" className="hero__shape hero__shape--two" />

      <div className="container container--custom">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-5 col-lg-8 mb-30">
            <div className="hero__content">
              <Fade direction="up" triggerOnce={false} duration={1200} delay={9}>
                <div>
                  <h1 className="hero__title hero__title--big">{t("hero_title")}</h1>
                </div>
                <div>
                  <p className="hero__text">{t("hero_text")}</p>
                </div>
              </Fade>
            </div>
          </div>

          {/* SAĞ TARAF – Yuvarlak Logo (sadece masaüstü) */}
          <div className="col-xl-6 mb-30 d-flex justify-content-center hero__round-logo">
            <Zoom triggerOnce={false}>
              <img
                src={logoBig}
                alt={t("logo_alt")}
                style={{
                  width: "720px",
                  height: "720px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                }}
              />
            </Zoom>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
